import propertyAPI from '../../../../services/api/property';
import { StyledLinkToProperty } from '../ListingCard.styles';

const CalcoloCanoneConcordatoLink = ({
  property_id,
}: {
  property_id: number;
}): JSX.Element => {
  const getCalcoloUrl = (property_id: number) => {
    return async (e: { preventDefault: () => void }) => {
      e.preventDefault();
      const confirmation = confirm(
        'Confermi di voler procedere con il calcolo del canone concordato? Tutte le richieste di calcolo precedenti verranno sovrascritte.',
      );
      if (confirmation === true) {
        try {
          const data = await propertyAPI.getCanoneConcordatoUrl(property_id);
          window.open(data.url, '_blank');
        } catch (error) {
          alert('si è verificato une errore, riprova più tardi');
        }
      }
      return false;
    };
  };

  return (
    <StyledLinkToProperty href="#" onClick={getCalcoloUrl(property_id)}>
      Calcola canone concordato
    </StyledLinkToProperty>
  );
};

export default CalcoloCanoneConcordatoLink;
